import Api from './api.service'

import Configuration from '@/configuration';
const baseURL = Configuration.value('apiFrontend')
const baseAdminURL = Configuration.value('apiBackend')

export default {
  getAll() {
    return Api().get(`${baseAdminURL}/offer`)
  },
  get() {
    return Api().get(`${baseURL}/offer`)
  }
}
